<template>
  <v-container>
    <v-row justify="center">
      <v-col cols="6">
        <evaluado-info-card-component :expediente="expediente[0]" />
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col cols="6">
        <v-card
          class="card"
          color="primary"
        >
          <v-card-title class="font-weight-bold justify-center">
            Captura de voz
          </v-card-title>
          <v-card-text>
            <v-form v-model="capturaFotoForm">
              <v-container>
                <v-row>
                  <v-col
                    cols="12"
                    class="pb-0"
                  >
                    <v-menu
                      ref="menu"
                      v-model="menu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      min-width="auto"
                    >
                      <template #activator="{ on, attrs }">
                        <v-text-field
                          v-model="fecha"
                          rounded
                          filled
                          dense
                          label="Fecha de realización *"
                          background-color="primary"
                          color="secondary"
                          v-bind="attrs"
                          readonly
                          append-icon="mdi-calendar"
                          :rules="nameRules"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        ref="picker"
                        v-model="fecha"
                        :max="new Date().toISOString().substr(0, 10)"
                        min="1950-01-01"
                        color="secondary"
                        @change="saveBirthdayDate(fecha)"
                      />
                    </v-menu>
                  </v-col>
                  <v-col cols="12">
                    <v-file-input
                      v-model="file"
                      label="Archivo de voz"
                      rounded
                      filled
                      background-color="primary"
                      color="secondary"
                      dense
                      :rules="nameRules"
                      prepend-icon="mdi-microphone"
                    />
                  </v-col>
                  <v-col cols="12">
                    <v-textarea
                      v-model="observaciones"
                      rounded
                      filled
                      dense
                      background-color="primary"
                      color="secondary"
                      label="Observaciones (Opcional)"
                      no-resize
                      rows="4"
                    />
                  </v-col>
                </v-row>
              </v-container>
            </v-form>
          </v-card-text>
          <v-card-actions class="justify-center pb-8">
            <v-btn
              color="secondary"
              class="primary--text px-8"
              :disabled="!capturaFotoForm || loading"
              @click="triggerSaveBiometrico()"
            >
              Registrar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-overlay
      :value="overlay"
      :z-index="999"
      align="center"
      color="secondary"
      opacity="1"
    >
      <v-progress-circular
        indeterminate
        color="primary"
      />
      <div class="text-overline mt-4">
        Cargando información. Por favor, espere...
      </div>
    </v-overlay>
  </v-container>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import moment from 'moment';
import EvaluadoInfoCardComponent from '../../components/EvaluadoInfoCardComponent.vue';

export default {
  components: {
    EvaluadoInfoCardComponent,
  },

  props: {
    idExpediente: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      loading: false,
      capturaFotoForm: false,
      menu: false,
      overlay: false,

      observaciones: '',
      fecha: null,
      file: null,
      nombre: null,

      nameRules: [(v) => !!v || 'Este campo es requerido.'],
    };
  },

  computed: {
    ...mapGetters('expediente', {
      expediente: 'getExpedientesPersonal',
    }),
  },

  async mounted() {
    this.overlay = true;
    await this.fetchExpedienteById(this.idExpediente);
    this.overlay = false;
  },

  methods: {
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapActions('biometrico', ['saveBiometrico']),
    ...mapActions('expediente', ['fetchExpedienteById']),

    async triggerSaveBiometrico() {
      this.loading = true;

      await this.saveBiometrico({
        fk_idExpediente: this.idExpediente,
        nombre: this.file.name,
        fechaRealizacion: moment(this.fecha).format('DD/MM/YYYY'),
        observaciones: this.observaciones,
        fk_idCatTipoBiometrico: 2,
        file: this.file,
      });

      this.SET_SNACKBAR_MESSAGE('Archivo de voz guardado correctamente.');
      this.loading = false;
      this.$router.push('/investigacion_socioeconomica/antecedentes');
    },

    saveBirthdayDate(date) {
      this.$refs.menu.save(date);
    },
  },
};
</script>
